import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';

import { ROUTE_STATUS } from '../../../../constants/Routes';
import { Route } from '../../../../domain/route/Route';
import { useUpdateRouteStatus } from './useUpdateRouteStatus';

interface UseStartRouteProps {
  driverRoute: Route;
}

type UseStartRouteResponseProps = ServiceResponse<Function, void>;

// Hooks act as 'Adapter' layer.
export const useStartRoute = ({ driverRoute }: UseStartRouteProps): UseStartRouteResponseProps => {
  const { run, isLoading, success, error } = useUpdateRouteStatus({
    driverRoute,
  });

  return {
    error,
    success,
    isLoading,
    run: () => {
      run({ status: ROUTE_STATUS.inTransit });
    },
  };
};
